import type { ReactNode } from 'react'
import { cn } from '@/lib/utils/helpers'

/**
 * Angular parity: always show the "Available Variables" info box
 * (`alert alert-info blue-bg`), even when the map is empty (before a
 * workflow is selected or when the workflow has no variables).
 */
export function EmailTemplateVariablesList({
  variables,
  className,
  title = 'Available Variables:',
  testId,
  footer,
}: {
  variables?: Record<string, string> | null
  className?: string
  title?: string
  testId?: string
  footer?: ReactNode
}) {
  const entries = Object.entries(variables ?? {})

  return (
    <div
      className={cn(
        'rounded-lg border border-sky-200 bg-sky-50 p-3 text-sm text-slate-800',
        className ?? 'mb-4',
      )}
      role="region"
      aria-label={title}
      data-testid={testId}
    >
      <h4 className="font-semibold text-slate-900">{title}</h4>
      {entries.length > 0 ? (
        <div className="mt-2 space-y-1">
          {entries.map(([key, value]) => (
            <p key={key} className="m-0 text-sm text-slate-800">
              <span className="font-medium">${key} -</span> {value}
            </p>
          ))}
        </div>
      ) : null}
      {footer}
    </div>
  )
}
